/** Decodes a preview payload into a PDF blob. Tolerates a data-URI prefix and a
 *  double-encoded payload; anything that is not a PDF is rejected instead of handed to
 *  the viewer (pdf.js would only report "Message: undefined"). */
export function pdfBlobFromBase64(base64: string): Blob {
  const raw = base64.replace(/^data:application\/pdf;base64,/, '');
  let binary = atob(raw);
  // 'JVBERi' is base64('%PDF-') — the payload was encoded twice
  if (binary.startsWith('JVBERi')) binary = atob(binary);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  if (binary.slice(0, 4) !== '%PDF') {
    console.warn('documents:preview payload is not a PDF', binary.slice(0, 120));
    throw new Error('preview payload is not a PDF');
  }
  return new Blob([bytes], { type: 'application/pdf' });
}
